import React, { useContext } from "react";
import { Button, Card, Result } from "antd";
import LoaderContext from "../../../Context/LoaderContext/Index";

interface SuccessResultProps {
  title: string;
  subTitle: string;
  onClick?: () => void;
  buttonTitle?: string;
}
const SuccessResult: React.FC<SuccessResultProps> = ({
  title,
  subTitle,
  onClick,
  buttonTitle,
}) => {
  const { isLoading } = useContext(LoaderContext);

  return (
    <Card>
      <Result
        status="success"
        title={title}
        subTitle={subTitle}
        extra={
          onClick && (
            <Button type="primary" onClick={onClick} loading={isLoading}>
              {buttonTitle ? buttonTitle : "Button"}
            </Button>
          )
        }
      />
    </Card>
  );
};

export default SuccessResult;
